import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { TNX_DASHBOARD_ROUTES } from './tnx-dashboard.routes';
import { TnxLoadListComponent } from './tnx-load-list/tnx-load-list.component';

@NgModule({
  imports: [
    RouterModule.forChild(TNX_DASHBOARD_ROUTES),
    SharedModule,
  ],
  declarations: [
    TnxLoadListComponent
  ],
})
export class TnxDashboardModule {
}
